var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "followUpRecord" },
    [
      _c(
        "div",
        { staticClass: "mb10 btn-box" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.addRecord },
            },
            [_vm._v("添加合同记录")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.addRecordShow
        ? _c("file-upload", {
            attrs: { formInfo: _vm.formInfo },
            on: { change: _vm.uploadChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "recordContent" },
        [
          _c(
            "el-timeline",
            _vm._l(_vm.liaisonData, function (activity, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: {
                    icon: activity.icon,
                    type: activity.type,
                    color: "#1890FF",
                    size: activity.size,
                  },
                },
                [
                  _vm.editIndex !== index
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "head" },
                            [
                              _c("img", {
                                staticClass: "head-portrait",
                                attrs: { src: activity.user.avatar, alt: "" },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "head-right" }, [
                                _c("span", { staticClass: "head-name" }, [
                                  _vm._v(_vm._s(activity.user.name)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "head-time" }, [
                                  _vm._v(_vm._s(activity.created_at)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-dropdown",
                                { staticClass: "more" },
                                [
                                  _c("i", { staticClass: "el-icon-more" }),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        width: "100px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleEdit(
                                                activity,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 编辑 ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleDelete(activity)
                                            },
                                          },
                                        },
                                        [_vm._v(" 删除 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "record" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(activity.content) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(activity.attachs, function (fileItem, g) {
                            return _c("div", { key: g, staticClass: "flex" }, [
                              _c("div", { staticClass: "fileItem" }, [
                                _vm.toSrc(fileItem.name) === 1
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("../../../../assets/images/doc.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.toSrc(fileItem.name) === 2
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("../../../../assets/images/ppt.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.toSrc(fileItem.name) === 3
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("../../../../assets/images/xls.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.toSrc(fileItem.name) === 4
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("../../../../assets/images/image.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.toSrc(fileItem.name) === 5
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("../../../../assets/images/pdf.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(fileItem.name) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt10" }, [
                                _vm.toSrc(fileItem.name) === 4
                                  ? _c("span", {
                                      staticClass: "iconfont iconyulan pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePictureCardPreview(
                                            fileItem.url
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "iconfont iconxiazai pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(
                                        fileItem.url,
                                        fileItem.name
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ])
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editIndex === index
                    ? _c("file-upload", {
                        attrs: { formInfo: _vm.formInfo },
                        on: { change: _vm.uploadChange },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.liaisonData.length == 0
        ? _c("div", { staticClass: "default" }, [
            _c("img", {
              staticClass: "img",
              attrs: {
                src: require("../../../../assets/images/def1.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("public.message14") + "~")),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }